import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loader = ({ loading, children }) => {
  return (
    <div className="loader-wrapper">
      {children}
      {loading && (
        <div className="loader-overlay">
          <Spinner animation="border">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
    </div>
  );
};

export default Loader;
